import { Component, OnInit, ViewChild, TemplateRef, Input } from '@angular/core';
import { IEpGridModel, EpLocalStorageService, EpEventService, EpGridEvent, IEpGridSelectionOptions, EpButtonStyle, IEpComponentEventArg } from '@epicor/kinetic';
import { BistrackConfig, LocalStorageSaveTypes, CustomEvents } from 'ep-bt-controls';
import { FieldAgentClient } from 'ep-bt-field-agent-proxy';
import { Router } from '@angular/router';
import { EpbtFieldAgentService } from '../../services/epbt-field-agent.service';
import { EpbtFaProductService } from '../../services/epbt-fa-product.service';
import { EpbtFaProductBinlocationService } from '../../services/epbt-fa-product-binlocation.service';
import { Location } from '@angular/common';

declare var $: any;

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'epbt-fa-bin-location-product-grid',
  templateUrl: './epbt-fa-bin-location-product-grid.component.html',
  styleUrls: ['./epbt-fa-bin-location-product-grid.component.scss']
})
export class EpbtFaBinLocationProductGridComponent implements OnInit {
  EpButtonStyle = EpButtonStyle;

  products: any;
  public gridModel: IEpGridModel;
  bistrackSettings: any;
  public pageSize = 10;
  currency: string;
  webTrackUser: any;
  branchId: number;
  customerId: number;
  public selectedProduct: any;
  private _searchString: string;
  bisTrackUserHasReadAccessToTheseBranches: any = [];
  @Input('searchString') set searchString(value: string) {
    this._searchString = value;
  }
  get searchString(): string { return this._searchString; }

  @ViewChild('currencyTemplate', {static: true }) currencyTemplate: TemplateRef<any>;
  @ViewChild('decimalTemplate', {static: true }) decimalTemplate: TemplateRef<any>;

  constructor(private client: FieldAgentClient, private router: Router, private config: BistrackConfig,
    public epEvent: EpEventService, private productService: EpbtFaProductService,
    private binLocationService: EpbtFaProductBinlocationService, private location: Location,
    private faService: EpbtFieldAgentService) {
    this.epEvent.onEvents([CustomEvents.BinLocationProductSearch]).subscribe(event => {
      this.getGridData();
    });
  }

  ngOnInit() {
    this.faService.getBisTrackSetting((bistrackSettings: any) => {
      this.bistrackSettings = bistrackSettings;
      this.currency = this.bistrackSettings.baseCurrency.symbol;
    });

    this.faService.getWebTrackUser((webTrackUser: any) => {
      this.webTrackUser = webTrackUser;
      this.branchId = this.webTrackUser.webTrackTradingBranch.branchID;
      this.bisTrackUserHasReadAccessToTheseBranches = this.webTrackUser.bisTrackUserHasReadAccessToTheseBranches;
      this.customerId = this.webTrackUser.customer.customerId;
      this.pageSize = 500;
      this.gridModel = this.getGridModel([]);
      this.getGridData();
    });
  }

  getGridModel(productList: any): IEpGridModel {
    const selectionOptions: IEpGridSelectionOptions = {
      selectByField: 'productId',
      selectedKeys: [],
    };
    const model: IEpGridModel = {
      resizable: false,
      reorderable: true,
      groupable: false,
      filterable: false,
      pageable: true,
      pageSize: this.pageSize,
      scrollable: 'scrollable',
      rowHeight: 20,
      height: this.getHeight(),
      sortable: true,
      selectionOptions: selectionOptions,
      data: productList,
      columns: [
        { field: 'productCode', title: 'CODE', width: 30, hidden: false },
        { field: 'description', title: 'DESCRIPTION', width: 30, hidden: false },
        { field: 'standardSellPrice', title: 'SELL PRICE', width: 30, hidden: false, cellTemplate: this.currencyTemplate },
        { field: 'stockAvailable', title: 'AVAIL', width: 30, hidden: false, cellTemplate: this.decimalTemplate },
        { field: 'binLocations', title: 'Bin(s)', width: 30, hidden: false }
      ],
      epOnComponentEvent: (eventArg: IEpComponentEventArg) => {
          if ( eventArg.eventId == 'epOnCellClick' && eventArg.event && eventArg.event.type == 'click') {
          this.selectedProduct = eventArg.event.dataItem;
        }
      },
      // fnEvent: (event: EpGridEvent, args: any) => {
      //   if (event === EpGridEvent.cellClick) {
      //     this.selectedProduct = args.dataItem;
      //   }
      // },
    };
    return model;
  }

  // grid height calculation start
  getHeight(): number {
    const height = parseInt($('body').height());

    if (height > 900) {
      // return 300;
      return 600;
    } else {
      return 550; // return 500;
    }
  }
  // grid height calculation end

  getGridData() {
    this.branchId = this.webTrackUser.webTrackTradingBranch.branchID;
    this.bisTrackUserHasReadAccessToTheseBranches = this.webTrackUser.bisTrackUserHasReadAccessToTheseBranches;
    this.customerId = this.webTrackUser.customer.customerId;
    this.pageSize = 100;
    this.productService.getProductListGridData(
      this._searchString, this.branchId, this.webTrackUser.bisTrackUserHasReadAccessToTheseBranches,
      this.bistrackSettings.searchMOLTsInProductFindInOrderEntry, this.customerId, this.pageSize, 0,
      (res: any) => {
      if (res != null) {
        this.products = res.lines;
      }
      if (this.products != null && this.products != undefined) {
        this.gridModel.data = this.products;
      }
    });
  }

  selectProductClick() {
    this.selectedProduct.dateTimeLastModified = this.faService.convertToUtc(new Date());
    this.productService.selectedProductItem = this.selectedProduct;
    this.binLocationService.selectedProducts.push(this.selectedProduct);
    this.location.back();
  }

  onCardClick(model) {
    this.selectedProduct = model;
  }
}
